import React from 'react';

import { TextTagStyles as s } from './TextTag.styles';

export type TextTagTheme = 'red' | 'white';

export interface TextTagProps {
  text?: string;
  theme?: TextTagTheme;
}

const TextTag: React.FC<TextTagProps> = ({ text, theme = 'red' }) => {
  return <s.Tag tagTheme={theme}>{text}</s.Tag>;
};

export default TextTag;
